import { caption } from './caption';
import { media } from './media';
import { unknown } from './unknown';
export const mediaGroup = (node, opts = {}) => {
  const result = [];
  node.forEach(n => {
    switch (n.type.name) {
      case 'media':
        result.push(media(n, {
          ...opts,
          parent: node
        }));
        break;
      case 'caption':
        result.push(caption(n, opts));
        break;
      default:
        result.push(unknown(n));
        break;
    }
  });
  return result.join('\n');
};